const { DirectUpload } = require("@rails/activestorage");

$(function () {
  var $container = $('#stock-images-field');
  if ($container.length === 0) return;

  var $fileInput = $('#stock_images');
  var $imageBoxWrap = $container.find('.image-box-wrap');
  var maxImages = Number($container.data('max-images')) || 5;
  var maxFileSize = Number($container.data('max-file-size')) || 5 * 1024 * 1024;
  var directUploadUrl = $fileInput.data('direct-upload-url');

  if (!directUploadUrl) return;

  var imageBoxCount = function () {
    return $imageBoxWrap.find('.stock-image-box').length;
  };

  var toggleFileInput = function () {
    if (imageBoxCount() >= maxImages) {
      $fileInput.prop('disabled', true);
    } else {
      $fileInput.prop('disabled', false);
    }
  };

  var revokeObjectUrl = function ($image) {
    var src = $image.attr('src');
    if (src && src.indexOf('blob:') === 0) {
      URL.revokeObjectURL(src);
    }
  };

  var validateFileSize = function (file) {
    if (file.size <= maxFileSize) return true;

    var maxFileSizeMb = Math.floor(maxFileSize / (1024 * 1024));
    alert('画像は' + maxFileSizeMb + 'MB以内にしてください');
    return false;
  };

  var createImageBox = function (previewUrl, signedId) {
    var $box = $('<div>', { class: 'image-box stock-image-box' });
    var $img = $('<img>', { class: 'stock_resales_image', src: previewUrl });
    var $hidden = $('<input>', {
      type: 'hidden',
      name: 'stock[images][]',
      value: signedId || '',
      class: 'stock-images-input'
    });
    var $edit = $('<a>', { href: '', class: 'btn-edit', text: '編集' });
    var $editInput = $('<input>', {
      type: 'file',
      class: 'edit-image-file-input file-input',
      style: 'display: none;'
    });
    var $delete = $('<a>', { href: '', class: 'btn-delete', text: '削除' });

    $box.append($img, $hidden, $edit, $editInput, $delete);
    return $box;
  };

  var uploadFile = function (file) {
    var def = $.Deferred();
    var upload = new DirectUpload(file, directUploadUrl);

    upload.create(function (error, blob) {
      if (error) {
        def.reject(error);
        return;
      }

      def.resolve(blob);
    });

    return def.promise();
  };

  var addImage = function (file) {
    if (!file) return;
    if (!validateFileSize(file)) return;
    if (imageBoxCount() >= maxImages) {
      toggleFileInput();
      return;
    }

    var previewUrl = URL.createObjectURL(file);
    var $box = createImageBox(previewUrl, '');
    $box.addClass('is-uploading');
    $imageBoxWrap.append($box);
    toggleFileInput();

    uploadFile(file)
      .done(function (blob) {
        $box.find('.stock-images-input').val(blob.signed_id);
        $box.removeClass('is-uploading');
      })
      .fail(function () {
        revokeObjectUrl($box.find('img'));
        $box.remove();
        toggleFileInput();
        alert('画像のアップロードに失敗しました');
      });
  };

  $fileInput.on('change', function (e) {
    var files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    files.forEach(function (file) { addImage(file); });

    $(this).val('');
  });

  $container.on('click', '.btn-edit', function (e) {
    e.preventDefault();
    $(this).closest('.stock-image-box').find('.edit-image-file-input').trigger('click');
  });

  $container.on('change', '.edit-image-file-input', function (e) {
    var file = e.target.files[0];
    if (!file) return;
    if (!validateFileSize(file)) {
      $(this).val('');
      return;
    }

    var $box = $(this).closest('.stock-image-box');
    var $image = $box.find('img');
    var nextPreviewUrl = URL.createObjectURL(file);
    $box.addClass('is-uploading');

    uploadFile(file)
      .done(function (blob) {
        revokeObjectUrl($image);
        $image.attr('src', nextPreviewUrl);
        $box.find('.stock-images-input').val(blob.signed_id);
        $box.removeClass('is-uploading');
      })
      .fail(function () {
        URL.revokeObjectURL(nextPreviewUrl);
        $box.removeClass('is-uploading');
        alert('画像のアップロードに失敗しました');
      });

    $(this).val('');
  });

  $container.on('click', '.btn-delete', function (e) {
    e.preventDefault();
    var $box = $(this).closest('.stock-image-box');
    revokeObjectUrl($box.find('img'));
    $box.remove();
    toggleFileInput();
  });

  toggleFileInput();
});
